import html from "./WebViewStep.html"
import webViewContent from "./WebViewContent.html"
import webViewStructuredHtml from "./WebViewStructuredHtml.html"
import appActionHandler from "../../../helpers/appActionHandler";
import { connectExternalAccount, promptForAccountRemoval } from '../../../helpers/providerAccounts';
import { getDeviceInfo } from "../../../helpers/MyDataHelps/participantDeviceInfo";
import { makeCssVars } from "../../../helpers/surveyLookAndFeelHelper"
import { acceptableEventSource, buildCurrentSurveyAnswers, getStepHtml, populateLegacyAnswerAndChoicesForQuestionSteps } from "../../../components/Survey/Util/webViewStepUtils"
import { getDelegatedAccessToken } from "../../../api/delegatedAccessToken"

var module = angular.module("ResearchKitApplicationModule");

module.value('delegatedOAuthClient', {});

module.directive("webViewStep", ["$timeout", "$window", "ceUrl", "delegatedOAuthClient", "$translate", "WebViewStepFrameUrl",
	function ($timeout, $window, ceUrl, delegatedOAuthClient, $translate, WebViewStepFrameUrl) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			},
			link: function (scope, iElement, iAttrs, controller) {

				var iFrame = $(iElement).find("iframe");
				var stepCompleted = false;

				var resetFrameHeight = function () {
					var position = iFrame.position();
					var targetHeight = $(iElement).parents(".current-survey-content").height() - position.top;
					iFrame.height(targetHeight);
				};

				if (scope.stepManager.surveyManager.getMode() !== "Design") {
					$($window).on("resize", resetFrameHeight);
				}

				$window.addEventListener("message", webViewMessageHandler);

				scope.$on("$destroy", function () {
					$window.removeEventListener("message", webViewMessageHandler);
				});

				scope.$on("connectExternalAccountDidFinish", function (event, parameters) {
					iFrame[0].contentWindow.postMessage({ action: event.name, messageID: parameters.messageID, success: parameters.success, errorMessage: parameters.errorMessage }, scope.frameUrl);
				});

				// HACK - See AppActionHandler setActionResult
				appActionHandler?.onMessageReceived(function (message) {
					iFrame?.[0]?.contentWindow?.postMessage(message, scope.frameUrl);
				});

				function webViewMessageHandler(event) {
					if (!acceptableEventSource(event, scope.frameUrl, iFrame.length ? iFrame[0].contentWindow : null))
						return;

					if (event.data && event.data.name === "RKStudioWebViewStepAnswer" || event.data.name === "CompleteStep") {
						if (!stepCompleted) {
							stepCompleted = true;
							scope.$apply(function () {
								scope.stepManager.childResults = [{
									Identifier: scope.stepManager.step.identifier,
									Type: "WebViewStepResult",
									StartDate: scope.stepManager.presentedDate,
									Result: event.data.answer
								}];
								scope.stepManager.continue();
							});
						}
					}
					else if (event.data && (event.data.name === "GetAccessToken" || event.data.name === "GetDelegatedAccessToken")) {
						scope.$apply(function () {
							if (scope.stepManager.surveyManager.participantID) {
								if (delegatedOAuthClient.standaloneMode) {
									return;
								}
								getDelegatedAccessToken({
									participantID: scope.stepManager.surveyManager.participantID,
									clientID: delegatedOAuthClient.ClientID,
									clientSecret: delegatedOAuthClient.ClientSecret,
									accessToken: appActionHandler.isEmbedded ? appActionHandler.token.access_token : undefined
								}).then(function (response) {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: response, messageID: event.data.messageID, baseUrl: $window.location.origin + ceUrl.getRoot() }, scope.frameUrl);
								}).catch(function () {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: false, message: "Unable to retrieve access token", messageID: event.data.messageID }, scope.frameUrl);
								});
							}
							else {
								iFrame[0].contentWindow.postMessage({ action: event.data.name, success: false, message: "Access token unavailable in this survey mode", messageID: event.data.messageID }, scope.frameUrl);
							}
						});
					} else if (event.data && event.data.name === "DeleteProviderAccount") {
						scope.$apply(function () {
							promptForAccountRemoval(event.data, iFrame[0].contentWindow, scope.frameUrl, $translate.instant('delete-account-confirm-message', null, null, 'Do you really want to delete this account?'));
						});
					} else if (event.data && event.data.name === "ConnectExternalAccount") {
						scope.$apply(function () {
							if (!appActionHandler.isEmbedded) {
								connectExternalAccount(
									event.data.externalAccountProviderID,
									event.data.messageID,
									event.data.openNewWindow,
									event.data.width,
									event.data.height);
							} else {
								appActionHandler.connectExternalAccount(event.data.externalAccountProviderID, { openNewWindow: event.data.openNewWindow, width: event.data.width, height: event.data.height }).then(function () {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, messageID: event.data.messageID }, scope.frameUrl);
								}).catch(function (error) {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: false, errorMessage: error, messageID: event.data.messageID }, scope.frameUrl);
								});
							}
						});
					}
					else if (event.data && (event.data.name === "GetDeviceInfo")) {
						scope.$apply(function () {
							if (!appActionHandler.isEmbedded) {
								var deviceInfo = getDeviceInfo();
								iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: deviceInfo, messageID: event.data.messageID }, scope.frameUrl);
							} else {
								appActionHandler.getDeviceInfo().then(function (deviceInfo) {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: deviceInfo, messageID: event.data.messageID }, scope.frameUrl);
								})
							}
						});
					}
					else if (event.data && (event.data.name === "ShowParticipantWebVisualizationPDF")) {
						scope.$apply(function () {
							if (!appActionHandler.isEmbedded) {
								scope.$apply(function () {
									scope.$emit("performAction", {
										type: "ShowParticipantWebVisualizationPDF",
										parameters: event.data,
										patientID: scope.stepManager.surveyManager.participantID
									});
								});
							} else {
								appActionHandler.showParticipantWebVisualizationPDF(event.data);
							}
						});
					}
					else if (event.data && (event.data.name === "GetStepConfiguration")) {
						scope.$apply(function () {

							var combinedStyles = angular.extend({}, scope.stepManager.surveyManager.template.styles, scope.stepManager.step.styles);
							var stepConfig = {
								styles: combinedStyles,
								properties: scope.stepManager.step.properties
							};

							iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: stepConfig, messageID: event.data.messageID }, scope.frameUrl);
						});
					}
					else if (event.data && (event.data.name === "GetSurveyContext")) {
						scope.$apply(function () {

							var surveyContext = {
								surveyMode: scope.stepManager.surveyManager.getMode()
							};

							iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: surveyContext, messageID: event.data.messageID }, scope.frameUrl);
						});
					}
					else if (event.data && (event.data.name === "GetCurrentSurveyAnswers")) {
						scope.$apply(function () {
							var surveyAnswers = buildCurrentSurveyAnswers(scope.stepManager.surveyManager.getResult(), scope.stepManager.surveyManager.template.steps);
							iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: surveyAnswers, messageID: event.data.messageID }, scope.frameUrl);
						});
					}
					else if (event.data && (event.data.name === "RequestSensorKitAuthorization")) {
						appActionHandler.requestSensorKitAuthorization(event.data);
					}
					else if (event.data && (event.data.name === "OpenEmbeddedUrl")) {
						if (appActionHandler.isEmbedded) {
							appActionHandler.openEmbeddedUrl(event.data.url);
						} else {
							window.open(event.data.url, "_blank");
						}
					}
					else if (event.data && (event.data.name === "OpenExternalUrl")) {
						if (appActionHandler.isEmbedded) {
							appActionHandler.openExternalUrl(event.data.url);
						} else {
							window.open(event.data.url, "_blank");
						}
					}
					else if (event.data && (event.data.name === "HealthConnectStatus")) {
						scope.$apply(function () {
							if (appActionHandler.isEmbedded) {
								appActionHandler.getHealthConnectStatus().then(function (status) {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: status, messageID: event.data.messageID }, scope.frameUrl);
								})
							}
						});
					}
					else if (event.data && (event.data.name === "HealthConnectPrompt")) {
						if (appActionHandler.isEmbedded) {
							appActionHandler.showHealthConnectPrompt();
						}
					}
					else if (event.data && (event.data.name === "HealthConnectPhrStatus")) {
						scope.$apply(function () {
							if (appActionHandler.isEmbedded) {
								appActionHandler.getHealthConnectPhrStatus().then(function (status) {
									iFrame[0].contentWindow.postMessage({ action: event.data.name, success: true, data: status, messageID: event.data.messageID }, scope.frameUrl);
								})
							}
						});
					}
					else if (event.data && (event.data.name === "HealthConnectPhrPrompt")) {
						if (appActionHandler.isEmbedded) {
							appActionHandler.showHealthConnectPrhPrompt();
						}
					}
					else if (event.data && (event.data.name === "HealthConnectSettings")) {
						if (appActionHandler.isEmbedded) {
							appActionHandler.showHealthConnectSettings();
						}
					}
					else if (event.data && (event.data.name === "HealthConnectMatchmaking")) {
						if (appActionHandler.isEmbedded) {
							appActionHandler.showHealthConnectMatchmakingPrompt();
						}
					}
				}

				function updateFrameUrl() {
					var language = $translate.use();
					var tempUrl = (scope.stepManager.step.url ? scope.stepManager.step.url : WebViewStepFrameUrl);
					if (language) {
						if (tempUrl.indexOf('?') >= 0) {
							tempUrl += `&lang=${language}`;
						} else {
							tempUrl += `?lang=${language}`;
						}
					}
					try {
						var checkUrl = new URL(tempUrl)
						if (_.contains(["http:", "https:"], checkUrl.protocol)) {
							scope.frameUrl = checkUrl.href;
						}
					} catch {
						// ignore invalid url
					}
				}

				function getCssVariableOverrides() {
					var styleSettings = angular.extend({}, scope.stepManager.surveyManager.template.styles, scope.stepManager.step.styles);
					var styleVars = makeCssVars(styleSettings);
					return styleVars.length ? `<style>:root { ${styleVars} }</style>` : "";
				}

				function reloadFrame() {
					var frameParent = iFrame.parent();
					iFrame.remove();
					iFrame = frameParent.append(frameElementDefinition);
					iFrame = $(frameParent).find("iframe");
					resetFrameHeight();

					let mode = scope.stepManager.step.contentMode || (scope.stepManager.step.url ? "specifyUrl" : "fullHtml");

					updateFrameUrl();

					let webContent = getStepHtml(scope.stepManager.step, scope.stepManager.surveyManager.template.webViewStepTemplates);

					if (mode === "partialHtml") {
						webContent = webViewStructuredHtml.replace(/{\s?html\s?}/g, webContent);
						webContent = webContent.replace(/{\s?cssVariableOverrides\s?}/g, getCssVariableOverrides());
					}

					let prependContent = webViewContent;
					let taskResult = populateLegacyAnswerAndChoicesForQuestionSteps(scope.stepManager.surveyManager.getResult(), scope.stepManager.surveyManager.template);
					let taskResultEncoded = _.escape(JSON.stringify(taskResult));
					prependContent = prependContent.replace(/{\s?taskResult\s?}/g, taskResultEncoded);
					let baseUrlEncoded = _.escape($window.location.protocol + "//" + $window.location.host + ceUrl.make("/"));
					prependContent = prependContent.replace(/{\s?baseUrl\s?}/g, baseUrlEncoded);
					webContent = prependContent + webContent;

					iFrame.off("load");
					iFrame.on("load", function () {
						this.contentWindow.postMessage({ name: "RKStudioStepContent", content: webContent }, scope.frameUrl);
					});
					iFrame.attr("src", scope.frameUrl);

					stepCompleted = false;
				}

				var reloadFrameDebounce = _.debounce(function () {
					reloadFrame();
				}, 50);

				scope.$watch("stepManager.step.html", reloadFrameDebounce);
				scope.$watch("stepManager.step.fieldValues", reloadFrameDebounce, true);
				scope.$watch("stepManager", reloadFrameDebounce);
				scope.$watch("stepManager", function () {
					if (scope.stepManager.surveyManager.getMode() !== "Design") {
						$timeout(resetFrameHeight, 0, false);
					}
				});

				let iframeSandboxAttributes = function () {
					let attributes = "allow-forms allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
					if (appActionHandler.isEmbedded) {
						attributes += " allow-top-navigation-by-user-activation"
					}
					return attributes;
				}

				const frameElementDefinition = `<iframe allowfullscreen src="" tabindex="0" style="border: none; padding: 0; margin: 0; width: 100%; display: block;" sandbox="${iframeSandboxAttributes()}" allow="camera; microphone; clipboard-write; geolocation"></iframe>`;
			}
		};
	}]
);